var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"QR-code Wrapper w-100 h-100"},[_c('div',{staticClass:"w-100 h-100 svg100",domProps:{"innerHTML":_vm._s(_vm.qrString)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }